import React from "react";
import {Link} from "react-router-dom";


export default function Faqs() {
    return (
        <section className="s-faq flat-spacing-25">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="sb-contact">
                            <p className="title">Contact Us</p>
                            <p className="sub">
                                Got a question or need assistance? Our team is here to help, Monday through Friday, 9:00
                                AM to 5:00 PM.
                            </p>
                            <p className="sub">
                                Refunds are typically issued within 6–12 business days after we receive your returned
                                package.
                            </p>

                            <div className="btn-group">
                                <Link
                                    to={`/contact-us`}
                                    className="tf-btn btn-fill hover-primary"
                                >
                                    Contact us
                                </Link>
                                <a href="#" className="tf-btn btn-white hover-primary">
                                    Chat with us
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <ul className="faq-list">
                            <li className="faq-item">
                                <p className="name-faq">Shopping Information</p>
                                <div className="faq-wrap" id="accordionShoping">
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                            role="button"
                                        >
                                            <span>How long will it take for my order to ship?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapseOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="headingOne"
                                            data-bs-parent="#accordionShoping"
                                        >
                                            <div className="accordion-body widget-desc">
                                                <p>
                                                    Orders are typically processed and shipped within 1–3 business days.
                                                    You'll receive a confirmation email once your order is on the way
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseTwo"
                                            role="button"
                                        >
                                            <span>Do you offer free shipping?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapseTwo"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingTwo"
                                            data-bs-parent="#accordionShoping"
                                        >
                                            <div className="accordion-body widget-material">
                                                <p>
                                                    Yes, we offer free standard shipping.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseFour"
                                            aria-expanded="false"
                                            aria-controls="collapseFour"
                                            role="button"
                                        >
                                            <span>What if my package is delayed or lost?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapseFour"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingFour"
                                            data-bs-parent="#accordionShoping"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    If your package is delayed or lost, please reach out to our customer
                                                    support. We’ll work with the carrier to locate your order or arrange
                                                    a replacement if necessary
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="faq-item">
                                <p className="name-faq">Payment Information</p>
                                <div className="faq-wrap" id="accordionPayment">
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapsePaymentOne"
                                            aria-expanded="true"
                                            aria-controls="collapsePaymentOne"
                                            role="button"
                                        >
                                            <span>What payment methods do you accept?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapsePaymentOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="headingOne"
                                            data-bs-parent="#accordionPayment"
                                        >
                                            <div className="accordion-body widget-desc">
                                                <p>
                                                    We accept all major credit cards, Stripe, Apple Pay, and Google Pay.
                                                    All transactions are secure and encrypted for your protection
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapsePaymentTwo"
                                            aria-expanded="false"
                                            aria-controls="collapsePaymentTwo"
                                            role="button"
                                        >
                                            <span>Is my payment information secure?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapsePaymentTwo"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingTwo"
                                            data-bs-parent="#accordionPayment"
                                        >
                                            <div className="accordion-body widget-material">
                                                <p>
                                                    Yes, your payment is 100% secure. We use Stripe, a leading and
                                                    trusted global payment processor, along with industry-standard
                                                    encryption to ensure your data is always protected.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapsePaymentThree"
                                            aria-expanded="false"
                                            aria-controls="collapsePaymentThree"
                                            role="button"
                                        >
                      <span>
                        Can I use multiple payment methods for my order?
                      </span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapsePaymentThree"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingThree"
                                            data-bs-parent="#accordionPayment"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    At this time, we only accept one payment method per order. We
                                                    recommend choosing the option that works best for you at checkout.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapsePaymentFour"
                                            aria-expanded="false"
                                            aria-controls="collapsePaymentFour"
                                            role="button"
                                        >
                                            <span>When will I be charged for my order?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapsePaymentFour"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingFour"
                                            data-bs-parent="#accordionPayment"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Your payment is processed immediately after you complete your
                                                    purchase. If there are any issues with the transaction, you’ll be
                                                    notified right away.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="faq-item">
                                <p className="name-faq">Return &amp; Exchange</p>
                                <div className="faq-wrap" id="accordionExchange">
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseExchangeOne"
                                            aria-expanded="true"
                                            aria-controls="collapseExchangeOne"
                                            role="button"
                                        >
                                            <span>What is your return policy?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapseExchangeOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="headingOne"
                                            data-bs-parent="#accordionExchange"
                                        >
                                            <div className="accordion-body widget-desc">
                                                <p>
                                                    We accept returns within 14 days of delivery. Items must be unworn,
                                                    unwashed, and in their original condition.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseExchangeTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseExchangeTwo"
                                            role="button"
                                        >
                                            <span>How do I return an item?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapseExchangeTwo"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingTwo"
                                            data-bs-parent="#accordionExchange"
                                        >
                                            <div className="accordion-body widget-material">
                                                <p>
                                                    If your order hasn't shipped, you can cancel it directly from your
                                                    orders page. Once it's shipped or received, simply make a refund request from your orders page and our
                                                    customer service team contact for return authorization, and we'll provide
                                                    you with return instructions.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="widget-accordion">
                                        <div
                                            className="accordion-title collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseExchangeThree"
                                            aria-expanded="false"
                                            aria-controls="collapseExchangeThree"
                                            role="button"
                                        >
                                            <span>When will I receive my refund?</span>
                                            <span className="icon icon-arrow-down"/>
                                        </div>
                                        <div
                                            id="collapseExchangeThree"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingThree"
                                            data-bs-parent="#accordionExchange"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Once your return is received and inspected, we will process the refund within 5-7 business days.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
